import React, { useRef, useState } from 'react';
import { Overlay, Popover, Button } from 'react-bootstrap';
import DateRange from '../Report/Controls/DateRange'
import { siteAccessCode } from '../database/apiv2SiteAccessor';
import { historicalReport } from '../database/apiUrls';
import SecondServer from '../database/SecondServer';

import "./HistoricalPopup.css"

let liftedFrom = undefined
let liftedUntil = undefined
let context = undefined
let [show, setShow] = []
let [footerMsg, setMsg] = []

const CustomPopover = React.forwardRef(({ style, ...props }, ref) => (
  <Popover id="custom-popover" ref={ref} style={{ ...style, '--bs-popover-max-width': '500px', left: 10, top: 10 }}>
    <Popover.Header>Historical Report</Popover.Header>
    {popoverBody()}
  </Popover>
));

function popoverBody() {
  return(
    <Popover.Body className='popoverLine'>
      <div className='popoverLine'>Enter the dates for this report and click Send. </div>
      <div className='popoverLine'>
        <DateRange singleLine='true' exporter={setTimes}/>
      </div>
      <div className='popoverButtons'>
        <Button onClick={historyNow}>Send</Button>
        <Button onClick={hideThis}>Cancel</Button>
      </div>
      <div className='error-style'>{footerMsg}</div>
    </Popover.Body>
  )
}
//    <Popover.Header as="h3">Historical Report</Popover.Header>
//    <Popover.Body>This popover is at a specific pixel location.</Popover.Body>
// <PopoverTitle>
// <PopoverContent>
function validate() {
  if (!liftedFrom || typeof liftedFrom !== 'object') {
    setMsg("Something's wrong with the From date, please try again")
    return false
  }
  if (!liftedUntil || typeof liftedUntil !== 'object') {
    setMsg("Something's funny with the To date, please try again")
    return false
  }
  if (liftedFrom.getTime() >= liftedUntil.getTime()) {
    setMsg("We need the From date to be earlier than To")
    return false
  }
  if (liftedUntil.getTime() - liftedFrom.getTime() > 86400000 * 90) {
    setMsg("That's too many reports. Please use a shorter interval")
    return false
  }
  return true
}
function historyNow () {
  if (!validate()) 
    return
  setMsg ("Working, hang on...")
  const ac = siteAccessCode(context.getActiveSite())
  const url = historicalReport(ac, liftedFrom, liftedUntil)
  const ss = new SecondServer(context)
  ss.apiInsertData (url).then ((resp) =>  {
    setMsg ("Report request submitted")
  })
  .catch((err) => {
    setMsg ("Error "+err)
  })
}
function hideThis () {
  setShow (false)
  setMsg ('')
}
function setTimes (from=undefined, until=undefined) {
  liftedFrom = from
  liftedUntil = until
}

export default function HistoryPopup(props) {
  [show, setShow] = useState(false);
  [footerMsg, setMsg] = useState('')
  const target = useRef(null);
  context = props
  return (
    <>
    <div className="rpt-edit rpt-place2" ref={target} onClick={()=>setShow(!show)}>Historical</div>
    <Overlay target={target.current} show={show} placement="bottom">
        {({ placement, arrowProps: _arrowProps, show: _show, popper, update, ...props }) => (
          <CustomPopover {...props} />
        )}
    </Overlay>
    </>
  );
}
